<template>
  <div id="customerServicePage">
    <CustomerService></CustomerService>
  </div>
</template>
<script>
import CustomerService from '@/components/customerService/CustomerService.vue'
export default {
  name: 'customerServicePage',
  components: {
    CustomerService,
  },
  data: function() {
    return {}
  },
}
</script>

<style scoped></style>
